<template>
    <div>
        <div
            class="mt-3"
        >
            <b-row>
                <b-col>
                    <b-form-group>
                        <label class="required text-dark font-weight-bold">CNPJ (Vencedor)</label>
                        <b-input-group>
                            <b-form-input
                                v-model="fornecedorVencedor.cpfCnpj"
                                v-mask="'##.###.###/####-##'"
                                placeholder="00.000.000/0000-00"
                                @input="$v.fornecedorVencedor.cpfCnpj.$touch()"
                                :state="$v.fornecedorVencedor.cpfCnpj.$error ? false : null"
                                @keypress.native.enter="obterFornecedor(removerMascara(fornecedorVencedor.cpfCnpj))"
                                @blur="obterFornecedor(removerMascara(fornecedorVencedor.cpfCnpj))"
                            />
                            <b-input-group-append>
                                <b-input-group-text v-if="pesquisandoFornecedor">
                                    <i class="fa fa-circle-o-notch fa-spin"></i>
                                </b-input-group-text>
                                <b-button
                                    v-if="!pesquisandoFornecedor"
                                    variant="primary"
                                    @click="obterFornecedor(removerMascara(fornecedorVencedor.cpfCnpj))"
                                    title="Clique para pesquisar o CNPJ"
                                >
                                    <i class="fa fa-search"></i>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group>
                        <label class="required text-dark font-weight-bold">Razão Social</label>
                        <div>
                            <div class="d-flex">
                                <b-form-input
                                    v-model="fornecedorVencedor.razaoSocial"
                                    disabled
                                />
                                <b-button
                                    variant="primary"
                                    ref="btnVincular"
                                    class="ml-4"
                                    :disabled="$v.$invalid"
                                    @click.stop="confirmarVinculoFornecedor"
                                    style="min-width: 130px;"
                                >
                                    Vincular
                                </b-button>
                            </div>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import PropostaPrecoServico from '../PropostaPrecoServico';
import FornecedoresServicos from '../../fornecedores/FornecedoresServicos';
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'VinculoFornecedor',
    props: {
        propostaPrecoId: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            fornecedorVencedor: {
                fornecedorId: '',
                cpfCnpj: '',
                razaoSocial: ''
            },
            pesquisandoFornecedor: false
        }
    },

    computed: {
    },

    validations: {
        fornecedorVencedor: {
            cpfCnpj: { required },
            razaoSocial: { required },
        }
    },

    methods: {

        limparForm(){
            this.fornecedorVencedor = {
                fornecedorId: '',
                cpfCnpj: '',
                razaoSocial: ''
            };
            this.$v.$reset();
        },

        removerMascara(texto) {
            if (!texto)
                return null;

            return texto.replace(/\D/g, '');
        },

        aplicarMascaraCnpj(valor) {
            if (!valor) return '';
            // Aplica a máscara CNPJ: 00.000.000/0000-00
            return valor
                .replace(/\D/g, '')
                .replace(/^(\d{2})(\d)/, '$1.$2')
                .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
                .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
                .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, '$1.$2.$3/$4-$5')
                .substr(0, 18);
        },

        obterFornecedor(cpfCnpj) {
            if (!cpfCnpj) return;

            this.pesquisandoFornecedor = true
            this.$store.dispatch('addRequest')

            FornecedoresServicos.obterPorCpfCnpj(cpfCnpj)
                .then(response => {
                    if (response.data) {
                        this.fornecedorVencedor = {
                            ...response.data,
                            cpfCnpj: this.aplicarMascaraCnpj(response.data.cpfCnpj)
                        };

                        this.$nextTick(() => {
                            if (this.$refs.btnVincular) {
                                this.$refs.btnVincular.focus();
                            }
                        });
                    }
                    else {
                        this.fornecedorVencedor = {};
                        this.$toast.error('CNPJ não encontrado. Tente novamente', 'Erro', this.$toastConfig.error)
                        PropostaPrecoServico.RegistrarTentativaVinculoCnpjNaoEncontrado(this.propostaPrecoId, cpfCnpj)
                    }
                })
                .catch(error => {
                    console.error('Erro ao obter fornecedor:', error)
                    this.fornecedorVencedor = {};
                    this.$toast.error(
                        'Erro ao obter fornecedor.',
                        'Erro',
                        this.$toastConfig.error
                    );
                })
                .finally(() => {
                    this.pesquisandoFornecedor = false
                    this.$store.dispatch('removeRequest')
                })
        },

        confirmarVinculoFornecedor() {
            this.$swal({
                title: 'Confirmação',
                html: `Deseja confirmar o vínculo do fornecedor ${this.fornecedorVencedor.razaoSocial}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.vincularFornecedor();
                }
            })
        },

        vincularFornecedor() {
            this.$store.dispatch('addRequest')

            PropostaPrecoServico.VincularFornecedor(this.propostaPrecoId, this.fornecedorVencedor.fornecedorId)
                .then(response => {
                    if (response.success) {
                        this.$toast.success('Fornecedor vinculado com sucesso', 'Sucesso', this.$toastConfig.success)
                        this.$toast.info('Um e-mail de notificação foi enviado ao fornecedor', 'E-mail enviado', this.$toastConfig.info)
                        this.$emit('fornecedorVinculado');
                    } else {
                        this.erros = response.errors || ['Erro ao vincular o fornecedor'];
                        this.$toast.error(
                            'Erro ao vincular o fornecedor!',
                            'Erro',
                            this.$toastConfig.error
                        );
                    }

                })
                .catch(error => {
                    console.error('Erro ao vincular fornecedor:', error)
                    this.$toast.error('Erro ao vincular fornecedor', 'Erro', this.$toastConfig.error)
                })
                .finally(() => {
			        this.$store.dispatch('removeRequest')
                });

        },

    },

    watch: {
        mostrarModal(newVal) {
            this.mostrarModalSolicitarDiligenciaFornecedor = newVal;
        },
    }
}
</script>
